import configJson from "./auth_config.json";
import { AUDIENCE } from "./constants/appConstants";
import { getDomainLocation } from "./util/util";

export function getConfig() {
let domainClient = configJson[getDomainLocation()];
  return {
    domain: domainClient.domain,
    clientId: domainClient.clientId,  
    audience: AUDIENCE
  };
}
